export default __webpack_public_path__ + "static/media/alignleft.719ebf4c.svg";